module.exports = __webpack_public_path__ + "9c9a5b02a8895453391b0c0195b073c4.pdf";